module.exports = __webpack_public_path__ + "img/brand-future-man-bg.ec3d0e8d.svg";